import { fg } from '@confluence/feature-gating';

export const useLivePageInviteNudgeV2Eligible = () => {
	return {
		isEligible: fg('livepageinvitenudgev2'),
	};
};
